var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgListIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 10,
  fill: "none",
  viewBox: "0 0 12 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 .75a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5m8.5 3.5h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1m0 4h-8a.5.5 0 0 0 0 1h8a.5.5 0 0 0 0-1M.75 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m0 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5"
})));
export { SvgListIcon as ReactComponent };
export default __webpack_public_path__ + "405c9e7ac368e81590f3247beffa45be.svg";